import React from 'react';

const messages = () => {
    return(
        <h1>Hello World</h1>
    )
}

export default messages;